import React from 'react'

const PdfIcon = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={30}
            fill="none"
            stroke="red"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.25}
            className="icon icon-tabler icons-tabler-outline icon-tabler-file-type-pdf"
            viewBox="0 0 24 24"
            {...props}
        >
            <path fill="#fff" stroke="none" d="M0 0h24v24H0z" />
            <path d="M14 3v4a1 1 0 0 0 1 1h4" />
            <path d="M5 12V5a2 2 0 0 1 2-2h7l5 5v4M5 18h1.5a1.5 1.5 0 0 0 0-3H5v6M17 18h2M20 15h-3v6M11 15v6h1a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-1z" />
        </svg>
    )
}

export default PdfIcon